import AddNotaPersona from "./AddNotaPersona";

export {AddNotaPersona}
export default AddNotaPersona
